import { HttpService } from '@/infra/http'

export type TConta = {
  id: string
  cnpj: string
  razaoSocial: string
  email?: string | null
  telefone?: {
    numero: string
    origem: 'Brasil' | 'Internacional'
  } | null
}

export class GetPessoaJuridicaCnpjService extends HttpService {
  async execute({ cnpj }: { cnpj: string }) {
    return this.http.get<TConta>(`api/v2/Conta/${cnpj}`)
  }
}
